"use strict";

var _objectSpread = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _formik = require("formik");
var yup = _interopRequireWildcard(require("yup"));
var _validation = require("./utils/validation");
var _helpers = require("./utils/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var PhoneCallImg = (0, _helpers.getImageByAgent)('phone-call.png');
var SMSImg = (0, _helpers.getImageByAgent)('SMSIcon.svg');
var SMSImgDisabled = (0, _helpers.getImageByAgent)('SMSIcon.svg');
var WhatsAppImg = (0, _helpers.getImageByAgent)('WhatsAppIcon.svg');
var WhatsAppImgDisabled = (0, _helpers.getImageByAgent)('WhatsAppIconDisabled.svg');
var otpMethodsIcons = {
  SMS: SMSImg,
  SMSDisabled: SMSImgDisabled,
  WhatsApp: WhatsAppImg,
  WhatsAppDisabled: WhatsAppImgDisabled
};
var OtpDetails = function OtpDetails(_ref) {
  var data = _ref.data,
    postOtpDetails = _ref.postOtpDetails,
    onChangeData = _ref.onChangeData,
    classes = _ref.classes,
    commonErrorMessage = _ref.commonErrorMessage,
    isLoading = _ref.isLoading,
    otpMethods = _ref.otpMethods,
    showNID = _ref.showNID,
    showWhatsappButton = _ref.showWhatsappButton;
  var _react$default$useSta = _react.default.useState(_objectSpread({
      fullname: '',
      phoneNumber: '',
      tou: false
    }, showNID && {
      nID: ''
    })),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    initialValues = _react$default$useSta2[0],
    setInitialValues = _react$default$useSta2[1];
  var firstPartOfTitle = /*#__PURE__*/
  // eslint-disable-next-line react/jsx-one-expression-per-line
  _react.default.createElement(_react.default.Fragment, null, " \u05DE\u05D9\u05D3 \u05E0\u05E9\u05DC\u05D7 \u05DC\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA ", /*#__PURE__*/_react.default.createElement("span", {
    className: classes.messageAccent
  }, " \u05E1\u05D9\u05E1\u05DE\u05D0 "), " ");
  var secondPartOfTitle = 'לצורך אימות ונעבור להצעות המחיר';
  var _react$default$useSta3 = _react.default.useState( /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, firstPartOfTitle), /*#__PURE__*/_react.default.createElement("div", null, secondPartOfTitle))),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    headerText = _react$default$useSta4[0],
    setHeaderText = _react$default$useSta4[1];
  _react.default.useEffect(function () {
    if (data) {
      setInitialValues(_objectSpread({
        fullname: data.fullname,
        phoneNumber: data.phoneNumber,
        tou: data.tou
      }, showNID && {
        nID: data.nID
      }));
    }
  }, [data]);

  // Check sessionStorage for otp:first
  _react.default.useEffect(function () {
    var landingParameters = JSON.parse(sessionStorage.getItem('landingParameters'));
    if (landingParameters && landingParameters.otp === 'first') {
      setHeaderText('הכל כבר מוכן והפרטים שמורים רק הזדהות קצרה ונצא לדרך');
    }
  }, []);
  var handleSubmit = function handleSubmit(values) {
    setInitialValues(values);
    postOtpDetails(values);
    onChangeData(values);
  };
  var updatedOtpMethods = showWhatsappButton ? otpMethods : otpMethods.filter(function (method) {
    return method !== 'WhatsApp';
  });
  var xsNumber = 12 / updatedOtpMethods.length;
  var generateButtons = function generateButtons(setFieldValue, params) {
    return updatedOtpMethods.map(function (method) {
      var commonProps = {
        'aria-label': params.isValid ? "".concat(method, " \u05E9\u05DC\u05D9\u05D7\u05EA") : 'שליחת סיסמא, יש למלא תחילה את כל פרטי הטופס',
        className: method === 'WhatsApp' ? classes.noFill : classes.submitButton,
        'data-testid': 'otp-detail-submit',
        disabled: params.isLoading || !params.isValid && params.dirty,
        endIcon: /*#__PURE__*/_react.default.createElement("img", {
          src: params.isLoading || !params.isValid && params.dirty ? otpMethodsIcons[method + 'Disabled'] : otpMethodsIcons[method],
          alt: method,
          className: method === 'WhatsApp' ? classes.buttonIconInvert : classes.buttonIcon
        }),
        label: params.isLoading ? /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null) : "\u05E9\u05DC\u05D9\u05D7\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA ".concat(method),
        onClick: function onClick() {
          return setFieldValue('otpMethod', method);
        },
        size: 'large',
        style: {
          textTransform: 'none'
        },
        type: 'submit'
      };
      return /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        key: method,
        style: {
          padding: '0'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
        key: method,
        sx: {
          flex: 1
        }
      }, commonProps), commonProps.label));
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: 'center',
    direction: 'row'
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 11
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: {
      md: 'none',
      xs: 'block'
    },
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: 115,
    src: PhoneCallImg,
    alt: 'phone call'
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: {
      md: 2,
      xs: 0
    },
    className: classes.messageTop
  }, headerText)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    component: _core.Box,
    display: {
      md: 'block',
      xs: 'none'
    },
    xs: 12,
    md: 5
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 0
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 10,
    component: _core.Box,
    pr: 8,
    style: {
      textAlign: 'center'
    },
    display: {
      md: 'block',
      xs: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: 131,
    src: PhoneCallImg,
    alt: 'phone call'
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 7
  }, commonErrorMessage ? /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.messageError
  }, commonErrorMessage)) : '', /*#__PURE__*/_react.default.createElement(_core.Box, {
    md: 3,
    mt: {
      md: 4,
      xs: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    onSubmit: handleSubmit,
    validationSchema: yup.object().shape({
      fullname: _validation.fullNameHebrewOnly,
      nID: yup.lazy(function () {
        if (showNID) {
          return _validation.validIsraeliId;
        }
        return yup.mixed().notRequired();
      }),
      phoneNumber: _validation.validPhone,
      tou: yup.boolean().oneOf([true], 'שדה חובה')
    }),
    initialValues: initialValues,
    enableReinitialize: true
  }, function (_ref2) {
    var values = _ref2.values,
      errors = _ref2.errors,
      touched = _ref2.touched,
      dirty = _ref2.dirty,
      isValid = _ref2.isValid,
      handleChange = _ref2.handleChange,
      handleBlur = _ref2.handleBlur,
      setFieldValue = _ref2.setFieldValue;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'otp-fullname',
      className: classes.formControl,
      autoComplete: 'off',
      label: 'שם מלא',
      onChange: handleChange,
      onBlur: handleBlur,
      name: "fullname",
      error: errors.fullname && touched.fullname,
      value: values.fullname,
      helperText: errors.fullname && touched.fullname ? /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'fullname'
      }) : ''
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'otp-phoneNumber',
      className: classes.formControl,
      autoComplete: 'off',
      label: 'טלפון',
      onChange: function onChange(e) {
        e.target.value = e.target.value.replace(/\D/g, '');
        handleChange(e);
      },
      onBlur: handleBlur,
      name: "phoneNumber",
      error: errors.phoneNumber && touched.phoneNumber,
      helperText: errors.phoneNumber && touched.phoneNumber ? /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'phoneNumber'
      }) : '',
      value: values.phoneNumber
    })), showNID && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'otp-nid',
      className: classes.formControl,
      autoComplete: 'off',
      label: 'תעודת זהות',
      onChange: handleChange,
      onBlur: handleBlur,
      name: "nID",
      error: errors.nID && touched.nID,
      helperText: errors.nID && touched.nID ? /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'nID'
      }) : '',
      value: values.nID
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      style: {
        paddingBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      wrap: "nowrap"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      id: 'otp-tou',
      inputProps: {
        'aria-label': 'אני מאשר מאשרת את תנאי השימוש ומאשר מאשרת קבלת תוכן פרסומי כאמור בתנאים המפורטים'
      },
      onChange: handleChange,
      onBlur: handleBlur,
      name: "tou",
      checked: values.tou
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.checkboxLabel
    }, "\u05D0\u05E0\u05D9 \u05DE\u05D0\u05E9\u05E8/\u05EA \u05D0\u05EA \u05EA\u05E0\u05D0\u05D9 \u05D4\u05E9\u05D9\u05DE\u05D5\u05E9 \u05D5\u05DE\u05D0\u05E9\u05E8/\u05EA \u05E7\u05D1\u05DC\u05EA \u05EA\u05D5\u05DB\u05DF \u05E4\u05E8\u05E1\u05D5\u05DE\u05D9 \u05DB\u05D0\u05DE\u05D5\u05E8", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Link, {
      href: _helpers.agentDeveloperUtils.getAgentLinks.termsAndConditions,
      target: "_blank"
    }, "\u05D1\u05EA\u05E0\u05D0\u05D9\u05DD \u05D4\u05DE\u05E4\u05D5\u05E8\u05D8\u05D9\u05DD")))), errors.tou && touched.tou ? /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
      error: true,
      className: classes.touError
    }, errors.tou) : ''), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      container: true,
      direction: "row",
      alignItems: "center"
    }, generateButtons(setFieldValue, {
      dirty: dirty,
      isLoading: isLoading,
      isValid: isValid
    }))));
  }))));
};
OtpDetails.propTypes = {
  classes: _propTypes.default.object,
  commonErrorMessage: _propTypes.default.string,
  data: _propTypes.default.object,
  isLoading: _propTypes.default.bool,
  onChangeData: _propTypes.default.func,
  otpMethods: _propTypes.default.array,
  postOtpDetails: _propTypes.default.func,
  showNID: _propTypes.default.bool,
  showWhatsappButton: _propTypes.default.bool
};
OtpDetails.defaultProps = {
  showNID: false
};
var _default = exports.default = OtpDetails;